
import { FC } from "react";
import { useNavigate } from "react-router-dom";

const IspaiHeader: FC = () => {
  const navigate = useNavigate();
  
  return <div className="flex items-center justify-between">
      <div>
        <img 
          src="/lovable-uploads/cc9b631c-7ea4-4370-9a8a-b314154af48d.png" 
          alt="iSPAI Logo" 
          className="w-48 h-48 object-contain cursor-pointer" 
          onClick={() => navigate("/engage")}
        />
      </div>
      <div>
        <h1 className="font-bold text-3xl">Integrated Special Purpose AI (iSPAI)</h1>
      </div>
    </div>;
};

export default IspaiHeader;
